import { BusEvent } from '@web/common';

export class AdminShippingMethodChangedBusEvent extends BusEvent {}
